export enum SearchSortEnum {
  COUNTRY = 'COUNTRY',
  REGION = 'REGION',
  LAST_UPDATED = 'LAST_UPDATED'
}
